import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';

interface LoadingStateProps {
  message?: string;
  height?: string | number;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Loading...",
  height = '50vh'
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height }}>
      <Typography variant="h6" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY }}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingState;